import type { EvnttzIconName } from './types'
import { EVNTTZ_ICON_NAMES } from './types'

export const EVNTTZ_ICON_LABELS: Record<EvnttzIconName, string> = {
  home: 'Início',
  journeys: 'Jornadas',
  missions: 'Missões',
  quizzes: 'Quizzes',
  prizes: 'Concursos',
  shop: 'Lojinha',
  social: 'Feed Social',
  schedule: 'Programação',
  library: 'Biblioteca',
  partners: 'Parceiros',
  support: 'Central de Ajuda',
  modules: 'Mais',
  backpack: 'Mochila',
  cellphone: 'Celular',
  file: 'Arquivo',
  folder: 'Pasta',
  handshake: 'Parceria'
}

/** Slug legado (sprite ou HugeIcon) → slug canônico */
export const LEGACY_ICON_ALIASES: Record<string, EvnttzIconName> = {
  chat: 'social',
  message: 'social',
  messages: 'social',
  partnership: 'partners',
  community: 'partners',
  users: 'partners',
  explore: 'journeys',
  goals: 'missions',
  tasks: 'quizzes',
  ticket: 'prizes',
  events: 'schedule',
  content: 'library',
  inventory: 'backpack',
  wallet: 'backpack',
  document: 'file'
}

const CANONICAL_SET = new Set<string>(EVNTTZ_ICON_NAMES)

export function resolveEvnttzIconName(slug: string | null | undefined): EvnttzIconName {
  if (!slug) return 'modules'
  if (CANONICAL_SET.has(slug)) return slug as EvnttzIconName
  return LEGACY_ICON_ALIASES[slug] ?? 'modules'
}

export function isEvnttzResolvableSlug(slug: string): boolean {
  return CANONICAL_SET.has(slug) || slug in LEGACY_ICON_ALIASES
}
